import Home from './../views/Home';
import Websites from './../views/Websites';
import MobileApps from './../views/MobileApps';
import Maintenance from './../views/Maintenance';
//import Solutions from './../views/Solutions';
import Story from './../views/Story';
import Contact from './../views/Contact';
import Privacy from './../views/Privacy';

export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/websites',
        name: 'Websites',
        component: Websites
    },
    {
        path: '/mobileapps',
        name: 'MobileApps',
        component: MobileApps
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance
    },
    {
        path: '/story',
        name: 'Story',
        component: Story
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy
    },
    {
        path: '*',
        name: '404',
        component: Privacy
    }

    /*{
    path: '/solutions',
    name: 'Solutions',
    component: Solutions
    },*/
];